import { useMutation as s } from "react-query";
import { useEnvironment as n } from "../../../common/hooks/environment/useEnvironment.js";
import { BookingAvailabilityItemAdapter as m } from "../../models/booking/availability/bookingAvailabilityItem.adapter.js";
import { getAdapter as a } from "../../adapter.js";
import { ScopeAdapter as p } from "../../models/scope/scope.adapter.js";
const c = 1;
function b() {
  const {
    backendBaseUrl: e
  } = n();
  return s(
    async (t) => {
      const o = await fetch(`${e}/booking/availability/`, {
        method: "post",
        body: JSON.stringify({
          ...t,
          action: c,
          scope: a(p).serialize(t.scope)
        })
      });
      if (o.status !== 200)
        throw new Error("Request failed");
      const r = a(m), i = await o.json();
      return {
        status: i.status,
        items: (i.items ?? []).map(r.adapt)
      };
    }
  );
}
export {
  b as useBookingAvailability
};
//# sourceMappingURL=useBookingAvailability.js.map
